var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsTagIcon = function SvgDsTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 8a.667.667 0 1 0 0-1.333A.667.667 0 0 0 6 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.132 1.206a1.33 1.33 0 0 1 1.732-.02l3.323 2.769c.304.253.48.628.48 1.024v7.688c0 .736-.597 1.333-1.334 1.333h-2.666c0 .736-.597 1.333-1.334 1.333H2.667A1.333 1.333 0 0 1 1.333 14V6.312c0-.395.176-.77.48-1.024L5.146 2.51a1.33 1.33 0 0 1 1.708 0l.404.337zm4.201 11.46h-2.666V6.313c0-.395-.176-.77-.48-1.024L8.295 3.711 10.01 2.21l3.323 2.769zM6 3.535 2.667 6.312V14h6.666V6.312z",
    clipRule: "evenodd"
  })));
};
export default SvgDsTagIcon;